import { render, staticRenderFns } from "./showNotif.vue?vue&type=template&id=35dd08bf&scoped=true&"
import script from "./showNotif.vue?vue&type=script&lang=js&"
export * from "./showNotif.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35dd08bf",
  null
  
)

export default component.exports